export const formatPhoneNum = phone => {
  const removedNonDigits = `${phone}`.replace(/\D/g, '');
  const matched = removedNonDigits.match(/^(\d{1,2})?(\d{3})(\d{3})(\d{4})$/);
  return matched
    ? matched[1]
      ? `+${matched[1].replace(/ /g, '')} (${matched[2]}) ${matched[3]} - ${matched[4]}`
      : `(${matched[2]}) ${matched[3]} - ${matched[4]}`
    : null;
};

export const formatPhoneNumOnChange = phone => {
  const reReplace = /[()]/g;
  const rePhone = /^(\+\d{1,2}\s+)?(\d{3})[\s]?(\d{3})?\s?-?\s?(\d{4})?/g;

  const matches = rePhone.exec(phone.replace(reReplace, '')) ?? [];

  const match1 = matches[1];
  const match2 = matches[2];
  const match3 = matches[3];

  const s1 = match1 ? `${match1.replace(/ /g, '')} ` : '';
  const s2 = match2 ? `(${match2}) ` : phone;
  const s3 = match3
    ? `${match3} - `
    : match1
    ? phone.substring(s1.length + s2.length)
    : phone.substring(s2.length);
  const s4 = phone.substring(s1.length + s2.length + s3.length);

  return s1 + s2 + s3 + s4;
};

export const isPhoneNum = phone => {
  const re = /^(\+\d{1,2}\s+)?(\(\d{3}\))[\s]?(\d{3})?\s?-?\s?(\d{4})$/g;
  return re.test(phone);
};
